import { FC } from "react";
import css from "./info-card.module.scss";

interface InfoCardProps {
    image: string;
    alt: string;
    title: string;
    description: string;
}

const InfoCard: FC<InfoCardProps> = ({ image, alt, title, description }) => {
    return (
        <div className={css.container}>
            <picture>
                <source srcSet={image} type="image/avif" />
                <img src={image} alt={alt} className={css.image} />
            </picture>
            <div className={css.text}>
                <h1 className={css.title}>{title}</h1>
                <p className={css.description}>{description}</p>
            </div>
        </div>
    );
};

export default InfoCard;